import {useConfigContext} from "../../../ConfigProvider.tsx";
import {useAutocomplete} from "../../context/GlobalContext";

export function ShowAllButton() {
    const {autocompleteState, totalHits} = useAutocomplete();
    const {tc, algoliaConfig: {customizedUrl}} = useConfigContext();
    const {collections, query} = autocompleteState;
    const productCollections = collections.filter(({source}) => source.sourceId === "products");
    const items = productCollections[0]?.items || [];
    if (query || items.length > 0) {
        return (
            <div className={"algoliaAutocompleteShowAllButton"}>
                <a
                    href={`/${customizedUrl}/search/?input_search=${encodeURIComponent(query)}`}
                    className="button button--bordered"
                >
                    {tc.all} {totalHits} {tc.showHits}
                </a>
            </div>)
    }else{
        return <></>
    }
}